import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Grid, Stack, Typography} from 'views/components';

import LoginInfo from './scenes/LoginInfo';
import UserLoggin from './scenes/user_authentication/UserAuthentication';
import UserForgotPassword from './scenes/user_forgot_password/UserForgotPassword';

const MAP = {
  'USER_LOGGIN': UserLoggin,
  'USER_FORGOT_PASSWORD': UserForgotPassword,
};

const Authentication = (props) => {
  const [authenticationState, setAuthenticationState] = React.useState('USER_LOGGIN');

  const LoginBox = MAP[authenticationState];

  if (!LoginBox) {
    return null;
  }


  return (
    <Box sx={{backgroundColor: 'color.white'}}>
      <Box
        sx={{
          py: {md: '16px', xs: '8px'},
          pl: '10%',
          background: {
            md: 'linear-gradient(90deg, #515151 0%, #111010 50.01%, #FFFFFF 50%)',
            xs: 'linear-gradient(90deg, #515151 0%, #111010 100%)',
          },
        }}
      >
        <Stack direction={'row'} >
          <Typography
            variant='h5'
            sx={{
              color: 'color.white',
            }}
          >
          Quilt
          </Typography>
        </Stack>
      </Box>
      <Grid container>
        <Grid item md={6} xs={12}
          order={{md: 2, xs: 1}}
          sx={{
            minHeight: {md: '95vh'},
            background: '#FFFFFF',
          }}
        >
          <LoginBox
            userForgotPassword={() => setAuthenticationState('USER_FORGOT_PASSWORD')}
            userLogin={() => setAuthenticationState('USER_LOGGIN')}
          />
        </Grid>
        <Grid item md={6} xs={12}
          order={{md: 1, xs: 2}}
          sx={{
            minHeight: {md: '95vh'},
            background: 'linear-gradient(90deg, #515151 0%, #111010 100%)',
          }}
        >
          <Box sx={{
            backgroundImage: `url('https://netflare.dev/images/background3.svg')`,
            backgroundSize: 'cover',
            height: '100%',
          }}>
            <LoginInfo/>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

Authentication.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Authentication));
